export default "__VITE_ASSET__BCyzak5k__"